import Svg from 'src/Components/shared/Svg'

export const TriangleSvg = props => (
  <Svg
    width='9'
    height='6'
    viewBox='0 0 9 6'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M4.5 6L9 1.3411e-07L0 0L4.5 6Z'
      fill='var(--brand-secondary-600)'
    />
  </Svg>
)
